/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { ComponentStripChartProps } from '../types';
// import phaseChart from '../../../assets/phase-chart.svg';
// import StripChartTable from './stripChartTable';
import { RootState } from '../../../redux/rootState';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../helper';

function ComponentStripsChart({ newDetails: newDeta̵ils, showSn, isMulti }: ComponentStripChartProps) {
  const { themePdfColor, reportPdfResponse1, tableContent } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const { BorderColor } = themePdfColor;
  // const CalibrationStripChartData = reportPdfResponse3?.Calibration_Strip_Charts;
  const getSection = (sec: string) => {
    const jobOrder = reportPdfResponse1?.VesselJobSubArrays?.find((job) => job?.JobOrder === newDeta̵ils?.JobOrder);
    const vessel = jobOrder?.Vessels?.find((vsl) => String(vsl?.VesselId) === newDeta̵ils?.VesselId);
    const one = vessel?.Layout === '2' ? 'Left' : 'Top';
    const two = 'Middle';
    const three = vessel?.Layout === '2' ? 'Right' : 'Bottom';
    if (vessel?.Section1Count === 0 || vessel?.Section2Count === 0 || vessel?.Section3Count === 0) {
      if (vessel?.Section1Count === 0) {
        return `${(sec === '2' ? one : (sec === '3' ? three : ''))} Section`;
      }
      if (vessel?.Section2Count === 0) {
        return `${(sec === '1' ? one : (sec === '3' ? three : ''))} Section`;
      }
      return `${(sec === '1' ? one : (sec === '2' ? three : ''))} Section`;
    }
    return `${(sec === '1' ? one : (sec === '2' ? two : three))} Section`;
  };
  return (
    <div className="p30">
      <div className="pageHeader">
        {showSn && (
        <div className="topHeader">
          <div>
            {ReportPart1(tableContent, CombineReportEnum.COMBINE_STRIP_CHARTS, PDFReportEnum.PDF_STRIP_CHARTS, 'Strip Charts')}
          </div>
          <div />
          <div>{`S/N ${reportPdfResponse1?.JobOrderData?.SerialNumber}`}</div>
        </div>
        )}
        {(showSn && newDeta̵ils?.IsCalibrationChart && <div className="underlineHeadingText textCenter">Calibration Page</div>)}
      </div>
      <div className="mediumHeadingText textCenter">
        {newDeta̵ils?.VesselName}
        {' '}
        {isMulti && newDeta̵ils?.IsCalibrationChart ? `(${getSection(newDeta̵ils?.Section)})` : 'Section'}
      </div>
      <div
        className="phaseChartImageContainer"
        style={{
          borderColor: BorderColor,
        }}
      >
        {newDeta̵ils?.ImageConfig ? (
          <img src={newDeta̵ils.ImageConfig} alt="Strip chart" />
        ) : (
          <div />
        )}
      </div>
      {/* <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '7px',
      }}
      >
        {
        !newDeta̵ils.IsCalibrationChart
          ? 'Note: Defects are compared to machined standards. Actual Defect Geometry may differ.'
          : `${newDeta̵ils.Title} (Row ${newDeta̵ils.Row} Tube ${newDeta̵ils.Tube})`
        }
      </div> */}
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '7px',
      }}
      >
        {newDeta̵ils.IsCalibrationChart ? (
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0px !important', lineHeight: '20px !important',
          }}
          >
            <p>Note: Defects are compared to machined standards.</p>
            <p style={{ marginTop: '-15px' }}>Actual Defect Geometry may differ.</p>
          </div>
        ) : (
          <p>{`${newDeta̵ils.Title && newDeta̵ils.Title?.length > 0 ? newDeta̵ils.Title : 'NO MEASURABLE DEFECTS '} (${isMulti ? `${getSection(newDeta̵ils?.Section)}, ` : ''}Row ${newDeta̵ils.Row} Tube ${newDeta̵ils.Tube})`}</p>
        )}

      </div>
    </div>
  );
}

export default ComponentStripsChart;
